import React from 'react';
import { isEmpty } from 'lodash/fp';
import AlertBox, { Heading } from 'components/shared/AlertBox';
import ScrollableContainer from 'components/shared/scrollable';
import { BlankSlate, Description } from 'components/_shared/blank_slate';
import noResultsSrc from 'images/content_no_results.svg';
import Image from '../../ImageLibrary/Image';
import DataProvider from '../../ImageLibrary/DataProvider';
import LoadableState from '../loadable';

const ImageLibraryPicker = ({ onDismiss, onSelect }) => (
  <DataProvider infinite>
    {({ images, hasMore, loadMore, updateQuery, loading, query }) => (
      <AlertBox wide className="ImageLibraryPicker" onDismiss={onDismiss}>
        <div className="d-f jc-sb ai-fs">
          <Heading>{t('image_library.select_image')}</Heading>
          <input
            placeholder={t('image_library.search_by_name')}
            onChange={e => updateQuery(e.target.value)}
            className="NewInput NewInput--light"
            type="search"
          />
        </div>
        <LoadableState loading={loading}>
          {!isEmpty(images) && (
            <ScrollableContainer maxHeight={480}>
              <div className="ImagesGrid">
                {images.map(image => (
                  <Image onClick={onSelect} image={image} key={image.id} />
                ))}
              </div>
              {hasMore && (
                <button
                  type="button"
                  className="u-linkBtn w-fill p-16 pt-0 o-0"
                  onClick={loadMore}
                >
                  Show More
                </button>
              )}
            </ScrollableContainer>
          )}
          {isEmpty(images) && !!query && (
            <BlankSlate>
              <img
                className="mw-300 mb-32"
                src={noResultsSrc}
                alt={t('image_library.no_results')}
              />
              <Description>{t('image_library.no_results')}</Description>
            </BlankSlate>
          )}
        </LoadableState>
      </AlertBox>
    )}
  </DataProvider>
);

export default ImageLibraryPicker;
